<template>
  <el-dialog
    title="模块设置"
    :visible.sync="showEditModal.flag"
    v-if="showEditModal.flag"
    width="900px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
  >
    <el-form
      :model="ruleFormApplet"
      ref="ruleFormApplet"
      :rules="rules"
      label-width="180px"
      class="form"
      size="small"
    >
      <div class="sub_title">浙政钉小程序</div>
      <!-- <el-row>
        <el-col>
          <el-form-item class="scale" label=" 模块名称类型：" required>
            <el-radio-group v-model="ruleFormApplet.moduleNameType">
              <el-radio
                v-for="item in moduleNameTypeData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleFormApplet.moduleNameType == 1">
        <el-col :span="24">
          <el-form-item label="模块名称：" prop="moduleName">
            <el-input
              placeholder="请输入模块名称"
              v-model="ruleFormApplet.moduleName"
              maxlength="15"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleFormApplet.moduleNameType == 2">
        <el-col :span="24">
          <el-form-item
            label="模块名称图片："
            prop="moduleNamePicUrl"
            :rules="[rulesFactory.required('请上传模块名称图片')]"
          >
            <div
              v-if="ruleFormApplet.moduleNamePicUrl"
              class="video-output"
              @mouseenter="showCover1 = true"
              @mouseleave="showCover1 = false"
            >
              <img :src="ruleFormApplet.moduleNamePicUrl" class="avatar" />
              <div v-show="showCover1" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="handleShowViewer1(1)"
                ></i>
                <i
                  class="el-icon-delete delete"
                  @click.stop="deleteCoverApplet(1, 1)"
                ></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="(val) => uploadCover1(val, 1)"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload1"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label v-if="!ruleFormApplet.moduleNamePicUrl" class="upload-text"
                >上传图片</label
              >
            </el-upload>
            <div class="upload_tip">
              <p class="img_tip">建议尺寸：686 px*39px</p>
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col>
          <el-form-item class="scale" label="入口启用：" required>
            <el-radio-group v-model="ruleFormApplet.isShow">
              <el-radio
                v-for="item in moduleShowData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="ruleFormApplet.isShow == 1">
        <el-row>
          <el-col>
            <el-form-item class="scale" label="启用时间：" required>
              <el-radio-group v-model="ruleFormApplet.showEnableType">
                <el-radio
                  v-for="item in showDateTypeData"
                  :key="item.paramKey"
                  :label="Number(item.paramKey)"
                  >{{ item.paramValue }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleFormApplet.showEnableType == 2">
            <el-form-item class="scale" prop="showDate">
              <el-date-picker
                unlink-panels
                v-model="ruleFormApplet.showDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="(val) => showDateChange(val, 1)"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col>
            <el-form-item class="scale" label=" 入口置顶：" required>
              <el-radio-group v-model="ruleFormApplet.isTop">
                <el-radio
                  v-for="item in isTopData"
                  :key="item.paramKey"
                  :label="Number(item.paramKey)"
                  >{{ item.paramValue }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ruleFormApplet.isTop == 1">
          <el-col>
            <el-form-item class="scale" label=" 置顶时间：" required>
              <el-radio-group v-model="ruleFormApplet.topEnableType">
                <el-radio
                  v-for="item in topEnableTypeData"
                  :key="item.paramKey"
                  :label="Number(item.paramKey)"
                  >{{ item.paramValue }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleFormApplet.topEnableType == 2">
            <el-form-item class="scale" prop="topDate">
              <el-date-picker
                unlink-panels
                v-model="ruleFormApplet.topDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="(val) => topDateChange(val, 1)"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="16">
            <el-form-item
              label="首页入口配图："
              class="scale"
              prop="indexUrl"
              :rules="[rulesFactory.required('请上传首页入口配图')]"
            >
              <div
                v-if="ruleFormApplet.indexUrl"
                class="video-output"
                @mouseenter="showCover2 = true"
                @mouseleave="showCover2 = false"
              >
                <img :src="ruleFormApplet.indexUrl" class="avatar" />
                <div v-show="showCover2" class="cover-bg">
                  <i
                    class="el-icon-zoom-in delete"
                    @click.stop="handleShowViewer2(1)"
                  ></i>
                  <i
                    class="el-icon-delete delete"
                    @click.stop="deleteCoverApplet(2, 1)"
                  ></i>
                </div>
              </div>
              <el-upload
                v-else
                action=""
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="(val) => uploadCover2(val, 1)"
                accept="png,jpg,jpeg"
                :limit="1"
                ref="coverUpload2"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <label v-if="!ruleFormApplet.indexUrl" class="upload-text"
                  >上传图片</label
                >
              </el-upload>
              <div class="upload_tip">
                <p class="img_tip">建议尺寸：1125px*632px</p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-popover placement="top-start" width="320" trigger="click">
              <div class="content">
                <!-- <img src="../../../assets/indexLiveExample.jpeg" /> -->
                <img
                  src="https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/ding/indexLiveExample.jpg"
                />
              </div>
              <div class="img_download_style" slot="reference">
                <span class="download_text">配图位置示意</span>
              </div>
            </el-popover>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item
              class="scale"
              label="小程序列表头图配图："
              prop="dingTopUrl"
              :rules="{
                required: true,
                message: '请上传图片',
              }"
            >
              <div
                v-if="ruleFormApplet.dingTopUrl"
                class="video-output"
                @mouseenter="showCover = true"
                @mouseleave="showCover = false"
              >
                <img :src="ruleFormApplet.dingTopUrl" class="avatar" />
                <div v-show="showCover" class="cover-bg">
                  <i
                    class="el-icon-zoom-in delete"
                    @click.stop="showAppletViewer = true"
                  ></i>
                  <i
                    class="el-icon-delete delete"
                    @click.stop="deleteCoverApplet(0, 1)"
                  ></i>
                </div>
              </div>
              <el-upload
                v-else
                action=""
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="uploadCover3"
                accept="png,jpg,jpeg"
                :limit="1"
                ref="coverUpload"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <label v-if="!ruleFormApplet.dingTopUrl" class="upload-text"
                  >上传图片</label
                >
              </el-upload>
              <div class="upload_tip">
                <p class="img_tip">建议尺寸：750px*272px</p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-popover placement="top-start" width="320" trigger="click">
              <div class="content">
                <!-- <img src="../../../assets/topLiveExample.jpeg" /> -->
                <img
                  src="https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/ding/topLiveExample.jpg"
                />
              </div>
              <div class="img_download_style" slot="reference">
                <span class="download_text">配图位置示意</span>
              </div>
            </el-popover>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-form
      :model="ruleFormPC"
      ref="ruleFormPC"
      :rules="rules2"
      label-width="180px"
      class="form"
      size="small"
    >
      <div class="sub_title">浙政钉PC端</div>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" 模块名称类型：" required>
            <el-radio-group v-model="ruleFormPC.moduleNameType">
              <el-radio
                v-for="item in moduleNameTypeData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleFormPC.moduleNameType == 1">
        <el-col :span="24">
          <el-form-item label="模块名称：" prop="moduleName">
            <el-input
              placeholder="请输入模块名称"
              v-model="ruleFormPC.moduleName"
              maxlength="15"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleFormPC.moduleNameType == 2">
        <el-col :span="24">
          <el-form-item
            label="模块名称图片："
            prop="moduleNamePicUrl"
            :rules="[rulesFactory.required('请上传模块名称图片')]"
          >
            <div
              v-if="ruleFormPC.moduleNamePicUrl"
              class="video-output"
              @mouseenter="showCover1 = true"
              @mouseleave="showCover1 = false"
            >
              <img :src="ruleFormPC.moduleNamePicUrl" class="avatar" />
              <div v-show="showCover1" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="handleShowViewer1(2)"
                ></i>
                <i
                  class="el-icon-delete delete"
                  @click.stop="deleteCoverApplet(1, 2)"
                ></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="(val) => uploadCover1(val, 2)"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload1"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label v-if="!ruleFormPC.moduleNamePicUrl" class="upload-text"
                >上传图片</label
              >
            </el-upload>
            <div class="upload_tip">
              <p class="img_tip">建议尺寸：686 px*39px</p>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="入口启用：" required>
            <el-radio-group v-model="ruleFormPC.isShow">
              <el-radio
                v-for="item in moduleShowData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="ruleFormPC.isShow == 1">
        <el-row>
          <el-col>
            <el-form-item class="scale" label="启用时间：" required>
              <el-radio-group v-model="ruleFormPC.showEnableType">
                <el-radio
                  v-for="item in showDateTypeData"
                  :key="item.paramKey"
                  :label="Number(item.paramKey)"
                  >{{ item.paramValue }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleFormPC.showEnableType == 2">
            <el-form-item class="scale" prop="showDate">
              <el-date-picker
                unlink-panels
                v-model="ruleFormPC.showDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="(val) => showDateChange(val, 2)"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item class="scale" label=" 入口置顶：" required>
              <el-radio-group v-model="ruleFormPC.isTop">
                <el-radio
                  v-for="item in isTopData"
                  :key="item.paramKey"
                  :label="Number(item.paramKey)"
                  >{{ item.paramValue }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ruleFormPC.isTop == 1">
          <el-col>
            <el-form-item class="scale" label=" 置顶时间：" required>
              <el-radio-group v-model="ruleFormPC.topEnableType">
                <el-radio
                  v-for="item in topEnableTypeData"
                  :key="item.paramKey"
                  :label="Number(item.paramKey)"
                  >{{ item.paramValue }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleFormPC.topEnableType == 2">
            <el-form-item class="scale" prop="topDate">
              <el-date-picker
                unlink-panels
                v-model="ruleFormPC.topDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="(val) => topDateChange(val, 2)"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item
              label="首页入口配图："
              class="scale"
              prop="indexUrl"
              :rules="[rulesFactory.required('请上传首页入口配图')]"
            >
              <div
                v-if="ruleFormPC.indexUrl"
                class="video-output"
                @mouseenter="showCover2 = true"
                @mouseleave="showCover2 = false"
              >
                <img :src="ruleFormPC.indexUrl" class="avatar" />
                <div v-show="showCover2" class="cover-bg">
                  <i
                    class="el-icon-zoom-in delete"
                    @click.stop="handleShowViewer2(2)"
                  ></i>
                  <i
                    class="el-icon-delete delete"
                    @click.stop="deleteCoverApplet(2, 2)"
                  ></i>
                </div>
              </div>
              <el-upload
                v-else
                action=""
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="(val) => uploadCover2(val, 2)"
                accept="png,jpg,jpeg"
                :limit="1"
                ref="coverUpload2"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <label v-if="!ruleFormPC.indexUrl" class="upload-text"
                  >上传图片</label
                >
              </el-upload>
              <div class="upload_tip">
                <p class="img_tip">建议尺寸：1125px*632px</p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-popover placement="top-start" width="500" trigger="click">
              <div class="content_pc">
                <!-- <img src="../../../assets/indexLiveExamplePC.jpeg" /> -->
                <img
                  src="https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/ding/indexLiveExamplePC.jpg"
                />
              </div>
              <div class="img_download_style" slot="reference">
                <span class="download_text">配图位置示意</span>
              </div>
            </el-popover>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="列表标题：" prop="listTitle">
              <el-input
                placeholder="请输入列表标题"
                v-model="ruleFormPC.listTitle"
                maxlength="15"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDialog()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="sureSubmit()" title="确定"></butn>
    </div>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showAppletViewer"
      :on-close="closeAppletViewer"
      :url-list="[ruleFormApplet.dingTopUrl]"
    />
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer1"
      :on-close="
        () => {
          showViewer1 = false;
        }
      "
      :url-list="
        activeTab == 1
          ? [ruleFormApplet.moduleNamePicUrl]
          : [ruleFormPC.moduleNamePicUrl]
      "
    />
    <el-image-viewer
      v-if="showViewer2"
      :on-close="
        () => {
          showViewer2 = false;
        }
      "
      :url-list="
        activeTab == 1 ? [ruleFormApplet.indexUrl] : [ruleFormPC.indexUrl]
      "
    />
  </el-dialog>
</template>
    
<script>
import { getSysParamByTypes } from "@/api/sysParam";
import FileHandler from "@/utils/file";
import rulesFactory from "@/utils/rules";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { indexModuleConfig, infoDeptUpdate } from "@/api/resourceService";
import butn from "@/components/button/index";
import moment from "moment";

export default {
  components: { butn, ElImageViewer },
  props: {
    showEditModal: {
      type: Object,
      default: function () {
        return {
          id: "",
        };
      },
    },
  },
  data() {
    return {
      rulesFactory,
      moduleNameTypeData: [],
      moduleShowData: [],
      showDateTypeData: [],
      isTopData: [],
      topEnableTypeData: [],
      // 小程序端&PC端
      showCover: false,
      showAppletViewer: false,
      showCover1: false,
      showCover2: false,
      showViewer1: false,
      showViewer2: false,
      activeTab: 1,
      // 小程序端
      ruleFormApplet: {
        bizType: 1, // 业务类型（1共富善治大讲堂）
        moduleType: 2, // 模块类型（DISPLAY_CLIENT_TYPE_APP 2小程序 3pc端）
        moduleNameType: null,
        moduleName: "",
        isShow: null,
        showEnableType: null,
        isTop: null,
        topEnableType: null,
        topDate: [],
        indexUrl: "",
        dingTopUrl: "",
        moduleNamePicUrl: "",
        showDate: [],
      },
      // PC端
      ruleFormPC: {
        bizType: 1,
        moduleType: 3,
        moduleNameType: null,
        moduleName: "",
        isShow: null,
        showEnableType: null,
        isTop: null,
        topEnableType: null,
        topDate: [],
        indexUrl: "",
        moduleNamePicUrl: "",
        showDate: [],
      },
      rules: {
        moduleName: [
          { required: true, message: "请输入模块名称", trigger: "blur" },
          rulesFactory.size("最多输入15个字", 0, 15),
        ],
        showDate: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || (!!value && value.length === 0)) {
                callback(new Error("请选择启用时间"));
              } else if (moment(value[0]) >= moment(value[1])) {
                callback(new Error("结束时间需大于开始时间"));
              } else {
                callback();
              }
            },
            trigger: ["change", "blur"],
          },
        ],
        topDate: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || (!!value && value.length === 0)) {
                callback(new Error("请选择置顶时间"));
              } else if (moment(value[0]) >= moment(value[1])) {
                callback(new Error("结束时间需大于开始时间"));
              } else {
                callback();
              }
            },
            trigger: ["change", "blur"],
          },
        ],
      },
      rules2: {
        moduleName: [
          { required: true, message: "请输入模块名称", trigger: "blur" },
          rulesFactory.size("最多输入15个字", 0, 15),
        ],
        showDate: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || (!!value && value.length === 0)) {
                callback(new Error("请选择启用时间"));
              } else if (moment(value[0]) >= moment(value[1])) {
                callback(new Error("结束时间需大于开始时间"));
              } else {
                callback();
              }
            },
            trigger: ["change", "blur"],
          },
        ],
        topDate: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || (!!value && value.length === 0)) {
                callback(new Error("请选择置顶时间"));
              } else if (moment(value[0]) >= moment(value[1])) {
                callback(new Error("结束时间需大于开始时间"));
              } else {
                callback();
              }
            },
            trigger: ["change", "blur"],
          },
        ],
        listTitle: [
          { required: true, message: "请输入列表标题", trigger: "blur" },
          rulesFactory.size("最多输入15个字", 0, 15),
        ],
      },
    };
  },
  created() {
    this.getIndexModuleConfig();
    this.getSysParamByTypes([
      "MODULE_NAME_TYPE",
      "MODULE_SHOW_TYPE",
      "MODULE_SHOW_DATE_TYPE",
      "MODULE_TOP_TYPE",
      "MODULE_TOP_DATE_TYPE",
    ]);
  },
  methods: {
    handleShowViewer1(type) {
      this.activeTab = type;
      this.showViewer1 = true;
    },
    handleShowViewer2(type) {
      this.activeTab = type;
      this.showViewer2 = true;
    },
    // 模块配置详情-clc
    getIndexModuleConfig() {
      indexModuleConfig().then((res) => {
        if (res.code !== 0) return;
        let resp = res.data;
        if (resp.length > 0) {
          for (let i = 0; i < resp.length; i++) {
            if (resp[i].showStartDate) {
              resp[i].showDate = [resp[i].showStartDate, resp[i].showEndDate];
            } else resp[i].showDate = [];
            if (resp[i].topStartDate) {
              resp[i].topDate = [resp[i].topStartDate, resp[i].topEndDate];
            } else resp[i].topDate = [];
            if (resp[i].moduleType == 2) {
              this.ruleFormApplet = resp[i];
            } else if (resp[i].moduleType == 3) {
              this.ruleFormPC = resp[i];
            }
          }
        }
      });
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.moduleNameTypeData = res.data["MODULE_NAME_TYPE"] || [];
        this.moduleShowData = res.data["MODULE_SHOW_TYPE"] || [];
        this.showDateTypeData = res.data["MODULE_SHOW_DATE_TYPE"] || [];
        this.isTopData = res.data["MODULE_TOP_TYPE"] || [];
        this.topEnableTypeData = res.data["MODULE_TOP_DATE_TYPE"] || [];
        if (!this.ruleFormApplet.uuid) {
          this.ruleFormApplet.moduleNameType = Number(
            this.moduleNameTypeData[0].paramKey
          );
          this.ruleFormApplet.isShow = Number(this.moduleShowData[0].paramKey);
          this.ruleFormApplet.showEnableType = Number(
            this.showDateTypeData[0].paramKey
          );
          this.ruleFormApplet.isTop = Number(this.isTopData[0].paramKey);
          this.ruleFormApplet.topEnableType = Number(
            this.topEnableTypeData[0].paramKey
          );
        }
        if (!this.ruleFormPC.uuid) {
          this.ruleFormPC.moduleNameType = Number(
            this.moduleNameTypeData[0].paramKey
          );
          this.ruleFormPC.isShow = Number(this.moduleShowData[0].paramKey);
          this.ruleFormPC.showEnableType = Number(
            this.showDateTypeData[0].paramKey
          );
          this.ruleFormPC.isTop = Number(this.isTopData[0].paramKey);
          this.ruleFormPC.topEnableType = Number(
            this.topEnableTypeData[0].paramKey
          );
        }
      });
    },
    async uploadCover3(e) {
      let file = e.file;
      // 上传前检查文件大小，超出3Mb终止上传
      if (file.size > 2 * 1024 * 1024) {
        this.$message.warning(`图片大小不能超过2Mb,请重新选择文件`);
        this.$refs["coverUpload"].clearFiles();
        return;
      }
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`indexModuleConfig/img`, file).then((res) => {
        const { url } = res;
        this.ruleFormApplet.dingTopUrl = url;
      });
    },
    // 上传WEB封面
    async uploadCover1(e, type) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload1"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`indexModuleConfig/img`, file).then((res) => {
        const { url } = res;
        if (type == 1) {
          this.ruleFormApplet.moduleNamePicUrl = url;
        } else this.ruleFormPC.moduleNamePicUrl = url;
      });
    },
    // 上传封面
    async uploadCover2(e, type) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload2"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`indexModuleConfig/img`, file).then((res) => {
        const { url } = res;
        if (type == 1) {
          this.ruleFormApplet.indexUrl = url;
        } else this.ruleFormPC.indexUrl = url;
      });
    },
    // 删除配图-小程序
    deleteCoverApplet(index, type = 1) {
      if (type == 1) {
        switch (index) {
          case 1: {
            this.ruleFormApplet.moduleNamePicUrl = "";
            break;
          }
          case 2: {
            this.ruleFormApplet.indexUrl = "";
            break;
          }
          default: {
            this.ruleFormApplet.dingTopUrl = "";
          }
        }
      } else {
        switch (index) {
          case 1: {
            this.ruleFormPC.moduleNamePicUrl = "";
            break;
          }
          case 2: {
            this.ruleFormPC.indexUrl = "";
            break;
          }
          default: {
            this.ruleFormPC.dingTopUrl = "";
          }
        }
      }
    },
    closeAppletViewer() {
      this.showAppletViewer = false;
    },
    /**
     * 启用时间变更
     */
    showDateChange(val, type) {
      if (type == 1) {
        this.ruleFormApplet.showDate = val;
        if (val && val.length > 1) {
          this.ruleFormApplet.showStartDate = val[0];
          this.ruleFormApplet.showEndDate = val[1];
        } else {
          this.ruleFormApplet.showStartDate = [];
          this.ruleFormApplet.showEndDate = [];
        }
      } else {
        this.ruleFormPC.showDate = val;
        if (val && val.length > 1) {
          this.ruleFormPC.showStartDate = val[0];
          this.ruleFormPC.showEndDate = val[1];
        } else {
          this.ruleFormPC.showStartDate = [];
          this.ruleFormPC.showEndDate = [];
        }
      }
    },
    /**
     * 置顶时间变更
     */
    topDateChange(val, type) {
      if (type == 1) {
        this.ruleFormApplet.topDate = val;
        if (val && val.length > 1) {
          this.ruleFormApplet.topStartDate = val[0];
          this.ruleFormApplet.topEndDate = val[1];
        }
      } else {
        this.ruleFormPC.topDate = val;
        if (val && val.length > 1) {
          this.ruleFormPC.topStartDate = val[0];
          this.ruleFormPC.topEndDate = val[1];
        }
      }
    },
    closeDialog() {
      this.$emit("closeDialog", false);
    },
    sureSubmit() {
      this.$refs["ruleFormApplet"].validate((valid) => {
        if (valid) {
          this.$refs["ruleFormPC"].validate((valid2) => {
            if (valid2) {
              let params = {
                indexModuleConfigDtoList: [],
              };
              params.indexModuleConfigDtoList[0] = this.ruleFormApplet;
              params.indexModuleConfigDtoList[1] = this.ruleFormPC;
              delete params.indexModuleConfigDtoList[0].showDate;
              delete params.indexModuleConfigDtoList[0].topDate;
              delete params.indexModuleConfigDtoList[1].showDate;
              delete params.indexModuleConfigDtoList[1].topDate;
              infoDeptUpdate(params).then((res) => {
                if (res && res.code == 0) {
                  this.$message.success(res.msg);
                  // 更新数据
                  this.$emit("closeDialog", true);
                }
              });
            }
          });
        }
      });
    },
  },
};
</script>
    
<style lang="scss" scoped>
$textColor: #51627d;
.sub_title {
  font-size: 1rem;
  height: 48px;
  line-height: 48px;
  background-color: #eee;
  font-weight: bold;
  padding: 0 12px;
  margin-bottom: 24px;
}
.m-l-24 {
  margin-left: 16px;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 320px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 320px;
  height: 160px !important;
  display: block;
  object-fit: contain;
}

.upload-text {
  color: $textColor;
  font-size: 13px;
}

.video-output {
  width: 320px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 320px;
  text-align: center;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 20px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}
.img_download_style {
  height: 160px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  font-size: 1rem;
  .download_text {
    color: #3a85ff;
    cursor: pointer;
  }
}
.content {
  width: 320px;
  height: 600px;
  overflow-x: hidden;
  overflow-y: scroll;
  img {
    width: 320px;
    height: auto;
  }
}
.content_pc {
  width: 500px;
  height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
  img {
    width: 500px;
    height: auto;
  }
}
</style>
    